<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">

          <div class=" col-lg-12 col-md-12 col-12" v-if="user.role==='3'">
            <div >
              <h2 class="text-white">Bienvenido {{ user.name }}</h2>
            </div>
          </div>
         

         
          <div class="col-lg-4 col-md-6 col-12"  v-if="user.role==='1' || user.role==='2'">
            <router-link 
            :to="{ name: 'Users' }" 
            class="card-link"
            
          >
            <card
              :title="stats.users.title"
              :value="stats.users.value"
               :percentage="stats.users.percentage"
              :iconClass="stats.users.iconClass"
              :iconBackground="stats.users.iconBackground"
              directionReverse
             
            ></card>
          </router-link>
          </div>

          <div class="col-lg-4 col-md-6 col-12" hidden  v-if="user.role==='1'">
            <router-link 
            :to="{ name: 'Payment' }" 
            class="card-link"
            
          >
            <card
              :title="'Licencia'"
              :value="license.status === 'paid' ? 'Pagado' : 
              license.status === 'pending' ? 'Pendiente' : 
              license.status === 'rejected' ? 'Rechazado' : 
              license.status === 'voided' ? 'Anulado' : 'Validando...'"
              :percentage="new Date(license.coverage_month).toLocaleDateString('es-ES')"
              :iconClass="'fa fa-id-card'"
              :iconBackground="'bg-gradient-dark'"
              :valueColor="getStatusColor(license.status)"
              :percentageColor="getStatusColor(license.status)"
              directionReverse
            ></card>
          </router-link>
          </div>
        
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";

export default {
  name: "dashboard-default",
  data() {
    return {
      stats: {
        projects: {
          title: "Citas programadas hoy",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-folder-17",
          detail: "since yesterday",
          iconBackground: "bg-gradient-info",
        },
        users: {
          title: "Usuarios",
          value: "0",
          percentage: "0%",
          iconClass: "ni ni-user-run",
          iconBackground: "bg-gradient-danger",
          detail: "since last week",
        },
      },
      user:{},
      undelivered:[],
      unvalidated:[],
      production:[],
      license:{}
    };
  },
  components: {
    Card,
  },
  methods: {
      async fetchAnalytics() {
        await this.$store.dispatch('analitycs/getCards'); 
        this.stats = this.$store.state.analitycs.cards;
      },
      async fetchUndelivered() {
        let datos = await this.$store.dispatch('analitycs/getUndelivered'); 
        this.undelivered = datos.data;
      },
      async fetchUnvalidated() {
        let datos = await this.$store.dispatch('analitycs/getUnvalidate'); 
        this.unvalidated = datos.data;
      },
      async fetchProduction() {
        let datos = await this.$store.dispatch('analitycs/getProduction'); 
        this.production = datos.data;
      },
      async fetchLicense() {
        this.license = await this.$store.dispatch('payments/get'); 
        console.log( this.license );
      },
      getStatusColor(status) {
        switch (status) {
          case 'paid':
            return 'text-success';  // Color verde para "Pagado"
          case 'pending':
            return 'text-warning';  // Color amarillo para "Pendiente"
          case 'rejected':
            return 'text-danger';   // Color rojo para "Rechazado"
          case 'voided':
            return 'text-muted';    // Color gris para "Anulado"
          default:
            return 'text-secondary'; // Color por defecto
        }
      }
  },
  mounted() {

    let user = JSON.parse(localStorage.getItem('user'));
    this.user = user;

    if(user.role==='1' || user.role==='2'){
      this.fetchAnalytics(); 
      this.fetchUndelivered(); 
      this.fetchUnvalidated(); 
      this.fetchProduction(); 
      this.fetchLicense();
    }

    
  },
};
</script>
